<template>
  <div class="pg-button-group" v-show="buttonAllShow || $slots.left || $slots.right">
    <slot name="left"></slot>
    <div class="pg-button-group__buttons">
      <template v-for="item in list">
        <template v-if="!item.leaf">
          <Dropdown
            class="pg-button-group__dropdown"
            trigger="hover"
            :key="item.id"
            v-show="buttonGroupShow(item)"
          >
            <ElButton
              :size="size"
              :type="type"
              :plain="plain"
              :round="round"
              :circle="circle"
              :icon="item.icon"
              >{{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i
            ></ElButton>
            <template v-slot:dropdown>
              <DropdownMenu class="pg-button-group__dropdown-menu">
                <DropdownItemButton
                  class="pg-button-group__dropdown-down-item"
                  v-for="dropItem in item.children"
                  :action="action"
                  :key="dropItem.code"
                  :size="size"
                  :class="{ 'pg-button-group__row-danger': dropItem.style === 'error' }"
                  type="text"
                  :plain="plain"
                  :round="round"
                  :circle="circle"
                  :menu="dropItem"
                  :compileData="compileData"
                  >{{ dropItem.name }}<PgTextTip :text="dropItem.title"
                /></DropdownItemButton>
              </DropdownMenu>
            </template>
          </Dropdown>
        </template>
        <ButtonItem
          v-else
          :key="item.id"
          :size="size"
          :class="{ 'pg-button-group__row-danger': item.style === 'error' }"
          :type="
            type !== 'text' && item.style === 'error'
              ? 'danger'
              : item.style === 'text'
              ? 'text'
              : type
          "
          :plain="plain"
          :round="round"
          :circle="circle"
          :action="action"
          :menu="item"
          :compileData="compileData"
          >{{ item.name }}<PgTextTip class="pg-button-group__buttons-tips" :text="item.title"
        /></ButtonItem>
      </template>
    </div>
    <slot name="right"></slot>
  </div>
</template>
<script setup>
import { toRef, inject } from 'vue'
import { Dropdown, DropdownMenu } from 'element-ui'
import ButtonItem from './button-item.vue'
import DropdownItemButton from './dropdown-item.vue'
import { useShowGroup } from '../hook/use-show'
import { BUTTONACTION } from '../../../tokens/index'
import { PgTextTip } from '../../text-tip/index'

const props = defineProps({
  list: Array,
  size: {
    type: String,
    default: 'small',
  },
  type: {
    type: String,
    default: 'primary',
  },
  plain: {
    type: Boolean,
    default: false,
  },
  round: {
    type: Boolean,
    default: true,
  },
  circle: {
    type: Boolean,
    default: false,
  },
  compileData: Object,
  customAction: Function, //默认使用注入的BUTTONACTION，也支持自定义
})

const { buttonAllShow, buttonGroupShow } = useShowGroup(
  toRef(props, 'compileData'),
  toRef(props, 'list')
)

const action = props.customAction ?? inject(BUTTONACTION, null)
</script>
<style lang="scss">
@import '../style/button-group.scss';
</style>
